"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ObiSpec = /*#__PURE__*/function () {
  function ObiSpec() {
    (0, _classCallCheck2["default"])(this, ObiSpec);
  }

  (0, _createClass2["default"])(ObiSpec, null, [{
    key: "fromSpec",
    value: function fromSpec(schema) {
      var _iterator = _createForOfIteratorHelper(ObiSpec.impls),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var impl = _step.value;

          if (schema.match(impl.REGEX)) {
            return new impl(schema);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      throw new Error("No schema matched: <".concat(schema, ">"));
    }
  }]);
  return ObiSpec;
}();

(0, _defineProperty2["default"])(ObiSpec, "impls", []);

var ObiInteger = /*#__PURE__*/function () {
  function ObiInteger(schema) {
    (0, _classCallCheck2["default"])(this, ObiInteger);
    this.isSigned = schema[0] === 'i';
    this.sizeInBytes = parseInt(schema.slice(1)) / 8;
  }

  (0, _createClass2["default"])(ObiInteger, [{
    key: "encode",
    value: function encode(value) {
      value = BigInt(value);
      return Buffer.from((0, _toConsumableArray2["default"])(Array(this.sizeInBytes)).map(function () {
        var _byte = value % BigInt(1 << 8);

        value /= BigInt(1 << 8);
        return parseInt(_byte);
      }).reverse());
    }
  }, {
    key: "decode",
    value: function decode(buff) {
      var value = BigInt(0);
      var multiplier = BigInt(1);

      for (var i = 0; i < this.sizeInBytes; i++) {
        value += BigInt(buff.readUInt8(this.sizeInBytes - i - 1)) * multiplier;
        multiplier = multiplier * BigInt(1 << 8);
      }

      return [value, buff.slice(this.sizeInBytes)];
    }
  }]);
  return ObiInteger;
}();

(0, _defineProperty2["default"])(ObiInteger, "REGEX", /^(u|i)(8|16|32|64|128|256)$/);

var ObiVector = /*#__PURE__*/function () {
  function ObiVector(schema) {
    (0, _classCallCheck2["default"])(this, ObiVector);
    this.internalObi = ObiSpec.fromSpec(schema.slice(1, -1));
  }

  (0, _createClass2["default"])(ObiVector, [{
    key: "encode",
    value: function encode(value) {
      var _this = this;

      return Buffer.concat([new ObiInteger('u32').encode(value.length)].concat((0, _toConsumableArray2["default"])(value.map(function (item) {
        return _this.internalObi.encode(item);
      }))));
    }
  }, {
    key: "decode",
    value: function decode(buff) {
      var _ObiInteger$decode = new ObiInteger('u32').decode(buff),
          _ObiInteger$decode2 = (0, _slicedToArray2["default"])(_ObiInteger$decode, 2),
          length = _ObiInteger$decode2[0],
          remaining = _ObiInteger$decode2[1];

      var value = [];

      for (var i = 0; i < parseInt(length); i++) {
        var decodeInternalResult = this.internalObi.decode(remaining);
        value.push(decodeInternalResult[0]);
        remaining = decodeInternalResult[1];
      }

      return [value, remaining];
    }
  }]);
  return ObiVector;
}();

(0, _defineProperty2["default"])(ObiVector, "REGEX", /^\[.*\]$/);

var ObiStruct = /*#__PURE__*/function () {
  function ObiStruct(schema) {
    (0, _classCallCheck2["default"])(this, ObiStruct);
    this.internalObiKvs = [];
    var curlyCount = 0;
    var kv = ['', ''],
        fill = 0; // 0 = k, 1 = v

    var _iterator2 = _createForOfIteratorHelper(schema.slice(1)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var c = _step2.value;
        if (c == '{') curlyCount++;else if (curlyCount && c == '}') curlyCount--;else if (!curlyCount && c === ':') {
          fill = 1;
          continue;
        } else if (!curlyCount && (c === ',' || c === '}')) {
          kv[1] = ObiSpec.fromSpec(kv[1]);
          this.internalObiKvs.push(kv);
          kv = ['', ''];
          fill = 0;
          continue;
        }
        kv[fill] += c;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  (0, _createClass2["default"])(ObiStruct, [{
    key: "encode",
    value: function encode(value) {
      return Buffer.concat(this.internalObiKvs.map(function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            k = _ref2[0],
            obi = _ref2[1];

        return obi.encode(value[k]);
      }));
    }
  }, {
    key: "decode",
    value: function decode(buff) {
      var value = {};
      var remaining = buff;

      var _iterator3 = _createForOfIteratorHelper(this.internalObiKvs),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = (0, _slicedToArray2["default"])(_step3.value, 2),
              k = _step3$value[0],
              obi = _step3$value[1];

          var decodeInternalResult = obi.decode(remaining);
          value[k] = decodeInternalResult[0];
          remaining = decodeInternalResult[1];
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return [value, remaining];
    }
  }]);
  return ObiStruct;
}();

(0, _defineProperty2["default"])(ObiStruct, "REGEX", /^{.*}$/);

var ObiString = /*#__PURE__*/function () {
  function ObiString() {
    (0, _classCallCheck2["default"])(this, ObiString);
  }

  (0, _createClass2["default"])(ObiString, [{
    key: "encode",
    value: function encode(value) {
      return Buffer.concat([new ObiInteger('u32').encode(value.length), Buffer.from(value)]);
    }
  }, {
    key: "decode",
    value: function decode(buff) {
      var _ObiInteger$decode3 = new ObiInteger('u32').decode(buff),
          _ObiInteger$decode4 = (0, _slicedToArray2["default"])(_ObiInteger$decode3, 2),
          length = _ObiInteger$decode4[0],
          remaining = _ObiInteger$decode4[1];

      return [remaining.slice(0, parseInt(length)).toString(), remaining.slice(parseInt(length))];
    }
  }]);
  return ObiString;
}();

(0, _defineProperty2["default"])(ObiString, "REGEX", /^string$/);

var ObiBytes = /*#__PURE__*/function () {
  function ObiBytes() {
    (0, _classCallCheck2["default"])(this, ObiBytes);
  }

  (0, _createClass2["default"])(ObiBytes, [{
    key: "encode",
    value: function encode(value) {
      return Buffer.concat([new ObiInteger('u32').encode(value.length), Buffer.from(value)]);
    }
  }, {
    key: "decode",
    value: function decode(buff) {
      var _ObiInteger$decode5 = new ObiInteger('u32').decode(buff),
          _ObiInteger$decode6 = (0, _slicedToArray2["default"])(_ObiInteger$decode5, 2),
          length = _ObiInteger$decode6[0],
          remaining = _ObiInteger$decode6[1];

      return [remaining.slice(0, parseInt(length)), remaining.slice(parseInt(length))];
    }
  }]);
  return ObiBytes;
}();

(0, _defineProperty2["default"])(ObiBytes, "REGEX", /^bytes$/);

var Obi = /*#__PURE__*/function () {
  function Obi(schema) {
    (0, _classCallCheck2["default"])(this, Obi);
    var normalizedSchema = schema.replace(/\s+/g, '');
    var tokens = normalizedSchema.split('/');
    this.inputObi = ObiSpec.fromSpec(tokens[0]);
    this.outputObi = ObiSpec.fromSpec(tokens[1]);
  }

  (0, _createClass2["default"])(Obi, [{
    key: "encodeInput",
    value: function encodeInput(value) {
      return this.inputObi.encode(value);
    }
  }, {
    key: "decodeInput",
    value: function decodeInput(buff) {
      var _this$inputObi$decode = this.inputObi.decode(buff),
          _this$inputObi$decode2 = (0, _slicedToArray2["default"])(_this$inputObi$decode, 2),
          value = _this$inputObi$decode2[0],
          remaining = _this$inputObi$decode2[1];

      if (remaining.length != 0) throw new Error('Not all data is consumed after decoding output');
      return value;
    }
  }, {
    key: "encodeOutput",
    value: function encodeOutput(value) {
      return this.outputObi.encode(value);
    }
  }, {
    key: "decodeOutput",
    value: function decodeOutput(buff) {
      var _this$outputObi$decod = this.outputObi.decode(buff),
          _this$outputObi$decod2 = (0, _slicedToArray2["default"])(_this$outputObi$decod, 2),
          value = _this$outputObi$decod2[0],
          remaining = _this$outputObi$decod2[1];

      if (remaining.length != 0) throw new Error('Not all data is consumed after decoding output');
      return value;
    }
  }]);
  return Obi;
}();

ObiSpec.impls = [ObiInteger, ObiVector, ObiStruct, ObiString, ObiBytes];
module.exports = {
  Obi: Obi,
  ObiSpec: ObiSpec,
  ObiInteger: ObiInteger,
  ObiVector: ObiVector,
  ObiStruct: ObiStruct,
  ObiString: ObiString,
  ObiBytes: ObiBytes
};